module.exports = __webpack_public_path__ + "media/audio30.47d595d4.mp3";